import React from 'react';
import { map, get, size } from 'lodash';
import { FlexContainer, MobileAcordion, Column, Text, Row, Truncate } from '../../../common';
import UserActions from './UserActions';
import StatusUserTag from './StatusUserTag';

const rows = [
    {
        label: 'Nombre',
        index: 'fullName',
        render: ({ firstName, lastName }) => <Text text={`${firstName} ${lastName}`} />
    },
    {
        label: 'Empresa',
        index: 'company'
    },
    {
        label: 'Rut',
        index: 'document'
    },
    {
        label: 'Estado',
        index: 'statusUser',
        render: ({ statusUser }) => <StatusUserTag value={statusUser} />
    },
    {
        label: 'Acciones',
        index: 'actions',
        render: (user, { onUserClicked, onClickTrash, ...props }, index) => {
            return (
                <UserActions
                    {...props}
                    onUserClicked={() => onUserClicked(user, index)}
                    onClickTrash={() => onClickTrash(user)}
                />
            );
        }
    }
];

const MobileTable = ({ data, ...props }) => {
    return map(data, (user, userIndex) => (
        <MobileAcordion
            key={userIndex}
            boxShadow
            left={
                <FlexContainer flex={1}>
                    <Column noFlex>
                        <Text text='ID' strong />
                    </Column>
                    <Column align='start' paddingHorizontal={10}>
                        <Truncate style={{ maxWidth: '65vw' }}>
                            <Text text={get(user, 'email', '-')} />
                        </Truncate>
                    </Column>
                </FlexContainer>
            }
            mB={8}
        >
            <FlexContainer direction='column' paddingVertical={8} paddingHorizontal={16}>
                { map(rows, ({ index, render = false, label, ...row }, id) => (
                    <Row key={index} pB={(id + 1) === size(rows) ? 0 : 10}>
                        <Column noFlex width={80} justify='center'>
                            <Text text={label} strong />
                        </Column>
                        <Column>
                            { (render && render(user, props, userIndex)) || <Text text={get(user, index, '-')} /> }
                        </Column>
                    </Row>
                )) }
            </FlexContainer>
        </MobileAcordion>
    ));
};

export default MobileTable;
